import type { FC, PropsWithChildren } from 'react';
import type { PathTranslations } from 'service/localization/getPathTranslations';
import type { DictionaryItem } from 'service/dictionary/dictionaryService';

import { GlobalContextProvider } from '@/components/Context/GlobalContext';
import { AiDisclosureProvider } from '@/components/AiDisclosure';
import RootLayoutClient, {
  type RootLayoutClientProps,
} from '@/components/PageLevelComponents/ClientLayout';
import RootSupremeLayoutClient from '@/components/PageLevelComponents/__themes__/supreme/ClientLayout';
import { AVAILABLE_THEMES } from '@/styles/constants';
import dynamic from 'next/dynamic';

export interface LayoutProps extends PropsWithChildren<RootLayoutClientProps> {
  pathTranslations: PathTranslations;
  locale: string;
  userToken: string;
  globalDictionary?: DictionaryItem[];
}

const Fonts = dynamic(() => import('@/components/Fonts'));

export const Layout: FC<LayoutProps> = ({
  children,
  themeName,
  locale,
  pathTranslations,
  userToken,
  globalDictionary = [],
  ...rest
}) => {
  let Component = RootLayoutClient;

  if (themeName === AVAILABLE_THEMES.suprema) {
    Component = RootSupremeLayoutClient;
  }

  return (
    <GlobalContextProvider
      value={{
        themeName,
        pathTranslations,
        userToken,
        globalDictionary,
      }}
    >
      <AiDisclosureProvider locale={locale}>
        <Fonts locale={locale} theme={themeName} />
        <Component {...rest} locale={locale} themeName={themeName}>
          {children}
        </Component>
      </AiDisclosureProvider>
    </GlobalContextProvider>
  );
};
